// extracted by mini-css-extract-plugin
module.exports = {"header-wrapper":"Organizers_header-wrapper__3ivIy","organizer-header":"Organizers_organizer-header__YJo3H","ieee":"Organizers_ieee__AmVmL","signal":"Organizers_signal__3msCn"};